import React from 'react';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img 
              src="https://customer-assets.emergentagent.com/job_kozlowski-fit/artifacts/vatwc7vo_6982b78e-8965-4993-bdac-c615559b3fd3-removebg-preview.png"
              alt="Paweł Kozłowski - Trener Personalny"
              loading="lazy"
            />
          </div>
          <div className="about-text">
            <h2 className="section-title">O Mnie</h2>
            <p className="about-description">
              Jestem certyfikowanym trenerem personalnym z wieloletnim doświadczeniem w branży fitness. 
              Moją pasją jest pomaganie ludziom w osiąganiu ich celów zdrowotnych i sylwetkowych poprzez 
              indywidualne podejście i profesjonalne wsparcie.
            </p>
            <p className="about-description">
              Specjalizuję się w treningach siłowych, redukcji tkanki tłuszczowej oraz budowaniu masy mięśniowej. 
              Łączę wiedzę z zakresu treningu z doradztwo dietetycznym, aby zapewnić kompleksowe wsparcie 
              na drodze do Twojej wymarzonej sylwetki.
            </p>
            <div className="about-highlights">
              <div className="highlight-item">
                <span className="highlight-icon">💪</span>
                <span className="highlight-text">Indywidualne Podejście</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-icon">🎯</span>
                <span className="highlight-text">Gwarantowane Rezultaty</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-icon">📱</span>
                <span className="highlight-text">Wsparcie Online</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
